import {gql} from 'apollo-angular';
import {ImageFragment} from "./Image";

export const ContactGalleryFragment = gql`
  fragment contactGalleryFields on ContactGallery {
    id
    galleryEntries {
      id
      enabled
      contact {
        employeePosition
        picture {
          ...imageFields
        }
        communication {
          id
          entries {
            id
            entryValue
            communicationType {
              name
              shortName
            }
          }
        }
        person {
          id
          firstname
          lastname
          sex
          titles {
            id
            shortName
            description
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
